import { useEffect } from "react";
import BopisModal from "../common";
import { LoadGoogleMapsJSApi } from "@lululemon/ufs-shared";
import { withErrorBoundary } from "@lululemon/mwa-common";
import useCdpBopisModalConnector from "./use-cdp-bopis-modal-connector";

const CdpBopisModalConnector = ({
  distanceFilter,
  googleMapsApiKey,
  isBopisTabActive,
  maxWidth,
  pdpShipBOPISRedesign,
  setDistanceFilter,
  setIsBopisModalOpen,
  setIsBopisTabActive,
  trackCDPBopis,
  useBopisLocation
}) => {
  const shouldFetchInventory = false;
  const flags = {
    ab: {
      pdpShipBOPISRedesign
    }
  };

  const {
    getUserAddressError,
    getUserCityState,
    handleGetUserAddress,
    handleOnSelectStore,
    hasCookieError,
    isLoadingUserAddress,
    setGetUserAddressError,
    userLocation,
    selectedStore,
    isLoadingUserSearchQuery,
    nearbyBopisStores,
    nearbyStoresWithInventoryButNoBopis,
    getAddressFromSearchQuery,
    userSearchedLocation,
    userSearchedQuery,
    setUserSearchedLocation,
    searchQueryError,
    setSearchQueryError
  } = useBopisLocation({ shouldFetchInventory });

  const {
    activeStoreRadioBtn,
    setActiveStoreRadioBtn,
    shouldDisplayProductInfoHeader
  } = useCdpBopisModalConnector(selectedStore);

  const onCloseModal = () => {
    setIsBopisModalOpen(false);
    setUserSearchedLocation(null);
    setActiveStoreRadioBtn(null);
    setGetUserAddressError(null);
    setSearchQueryError(null);
  };

  const onSelectStoreClickHandler = async () => {
    handleOnSelectStore(activeStoreRadioBtn);

    if (!isBopisTabActive) {
      setIsBopisTabActive(true);
    }
    trackCDPBopis({ storeName: activeStoreRadioBtn.name }); // @BOPISCDPTODO - Is this analytics needed?
    onCloseModal();
  };

  useEffect(() => {
    if (!userLocation.city && !userLocation.address) {
      getUserCityState();
    }
  }, []);

  return (
    <>
      <LoadGoogleMapsJSApi
        processNodeEnv={process?.env?.NODE_ENV}
        googleMapsApiKey={googleMapsApiKey}
      />
      <BopisModal
        {...{
          activeStoreRadioBtn,
          distanceFilter,
          flags,
          getAddressFromSearchQuery,
          getUserAddressError,
          handleGetUserAddress,
          hasCookieError,
          isLoadingUserAddress,
          isLoadingUserSearchQuery,
          maxWidth,
          nearbyBopisStores,
          nearbyStoresWithInventoryButNoBopis,
          onCloseModal,
          onSelectStoreClickHandler,
          searchQueryError,
          selectedStore,
          setActiveStoreRadioBtn,
          setDistanceFilter,
          setUserSearchedLocation,
          setGetUserAddressError,
          shouldDisplayProductInfoHeader,
          userLocation,
          userSearchedLocation,
          userSearchedQuery
        }}
      />
    </>
  );
};

CdpBopisModalConnector.displayName = "CdpBopisModalConnector";
export default withErrorBoundary({
  componentName: "CdpBopisModalConnector"
})(CdpBopisModalConnector);
